// Utility helper for building Data Domain URLs with query parameters.
// This central function keeps URL generation consistent across the app.

/**
 * Build a /dataDomain URL with optional l1-l5 query parameters.
 *
 * @param {Object} params
 * @param {string} params.selectedL1
 * @param {string} params.selectedL2
 * @param {string} params.selectedL3
 * @param {string} params.selectedL4
 * @param {string} params.selectedL5
 * @param {Object} options
 * @param {boolean} options.usePlusForSpace - if true, encodes spaces as `+` instead of `%20`
 * @param {string[]} options.dataLayers
 */
export function buildDataDomainUrl(
  {
    selectedL1,
    selectedL2,
    selectedL3,
    selectedL4,
    selectedL5,
  } = {},
  { usePlusForSpace = false, dataLayers = [] } = {},
) {
  const params = new URLSearchParams();

  if (selectedL1) params.set("l1", selectedL1);
  if (selectedL2) params.set("l2", selectedL2);
  if (selectedL3) params.set("l3", selectedL3);
  if (selectedL4) params.set("l4", selectedL4);
  if (selectedL5) params.set("l5", selectedL5);

  if (Array.isArray(dataLayers)) {
    dataLayers.forEach((layer) => {
      if (layer && String(layer).trim()) {
        params.append("data_layer", String(layer).trim());
      }
    });
  }

  let qs = params.toString();
  if (usePlusForSpace) {
    qs = qs.replace(/%20/g, "+");
  }

  return `/dataDomain${qs ? `?${qs}` : ""}`;
}
